import { useState } from 'react';
import ResetPasswordForm from '../../../components/forms/resetPassword/resetPassword.form';
import { confirmResetPassword, updatePassword } from '../../../services/user.service';
import { useSnackbars } from '../../../hooks/snackbar.hook';
import { AxiosError } from 'axios';
import { showAxiosMessageError } from '../../../utils/error-message.util';
import { ResetPasswordDto } from '../../../services/dtos/reset-password.dto';
import { useAuth } from '../../../hooks/use-auth.hook';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * Page de modification de mot de passe
 * @constructor
 */
export default function ResetPasswordPage() {
    //SnackBar
    const showMessage = useSnackbars();
    //Disable ou non le bouton de la validation
    const [loading, setLoading] = useState(false);
    //Récupération du contexte
    const auth = useAuth();
    //Navigate
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') ?? '';
    const requiresCurrentPassword = '' === token;

    // Comportement au submit du formulaire Login
    const handlerSubmit = async (form: ResetPasswordDto) => {
        if (requiresCurrentPassword) {
            if (!auth?.user?.id) {
                return;
            }

            setLoading(true);
            updatePassword(form)
                .then(() => {
                    showMessage.successAlert('Le mot de passe a bien été modifié');
                    const user = auth?.user;
                    if (user) {
                        user.resetPassword = false;
                        globalThis.localStorage.setItem('user', JSON.stringify(user));
                    }
                    navigate('/');
                })
                .catch((error: Error | AxiosError) => {
                    showAxiosMessageError(error, showMessage);
                })
                .finally(() => {
                    setLoading(false);
                });

            return;
        }

        setLoading(true);
        confirmResetPassword(token, form)
            .then(response => {
                showMessage.successAlert(response.status);
                auth.signout();
                navigate('/');
            })
            .catch((error: Error | AxiosError) => {
                showAxiosMessageError(error, showMessage);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <ResetPasswordForm
            handlerSubmit={handlerSubmit}
            loading={loading}
            requireCurrentPassword={requiresCurrentPassword}
            title={requiresCurrentPassword ? 'Changer mon mot de passe' : 'Réinitialiser mon mot de passe'}
        />
    );
}
